import { z } from 'zod';

export const reportChatSchema = z.object({
  reportReason: z.string().min(1, 'Report reason is required'),
  reportDescription: z.string().optional(),
});

export type ReportChatFormValues = z.infer<typeof reportChatSchema>;
